import React, { useMemo } from "react";
import { Box, Modal, Text } from "@mantine/core";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { useAppSelector } from "../../app/hooks";
import { selectSelectedRoutingGraph } from "./routingSelectors";
import { routingGraphToSchemaPixGeometry } from "./routingGraphSchemaUtils";

type RoutingGraphSchemaModalProps = {
  onClose: () => void;
};

export const RoutingGraphSchemaModal: React.FC<RoutingGraphSchemaModalProps> = ({ onClose }) => {
  const routingGraph = useAppSelector(selectSelectedRoutingGraph);
  const schemaGeometry = useMemo(
    () => (routingGraph ? routingGraphToSchemaPixGeometry(routingGraph) : null),
    [routingGraph]
  );

  return (
    <Modal
      opened
      onClose={onClose}
      title="Flytskjema"
      fullScreen
      styles={{
        body: {
          height: "calc(100vh - 57px)",
          padding: 0,
          backgroundColor: "white",
        },
      }}
    >
      <Box h="100%">
        {schemaGeometry ? (
          <Box
            h="100%"
            style={{
              backgroundColor: "white",
            }}
          >
            <DeckBimViewer
              flip2dCoordinate={false}
              angle={0}
              polygons={schemaGeometry.pixPolygons}
              paths={schemaGeometry.pixPaths}
              zoomExtentKey={
                routingGraph?._id != null ? String(routingGraph._id) : "routing-schema"
              }
              useLeftClickToPan
            />
          </Box>
        ) : (
          <Text size="sm" c="dimmed">
            Ingen rørgraf valgt.
          </Text>
        )}
      </Box>
    </Modal>
  );
};
